import styled from 'styled-components';

import { TextBox } from '@ecp/common/src/text/TextBox';

import { ReactComponent as CloseButton } from '@fo-assets/icon/skypass/icon_mileage_close.svg';

const Container = styled.div`
  position: absolute;
  align-items: center;
  right: 0;
  display: flex;
  height: 34px;
  padding: 8px 24px;
  border-radius: 34px;
  background: ${(props) => props.theme.color.background.basic};
  gap: 16px;
`;

const VerticalDivider = styled.div`
  width: 2px;
  height: 14px;
  background-color: ${(props) => props.theme.color.primary};
`;

const MileageTextBox = styled(TextBox)`
  font-size: 12px;
  width: 170px;
  display: flex;
  justify-content: flex-end;
  padding-right: 16px;
`;

const CloseButtonWrap = styled(CloseButton)`
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 15px;
`;

const ShowMileageButton = styled(TextBox)`
  font-size: 12px;
  border-bottom: 1px solid ${(props) => props.theme.color.primary};
  cursor: pointer;
  margin-left: 30px;
  margin-right: 50px;
`;

export { Container, VerticalDivider, MileageTextBox, CloseButtonWrap, ShowMileageButton };
